<template>
  <span :class="$attrs.class">
    <component :is="icon" />
  </span>
</template>
<script lang="ts" setup>
import type { Component } from 'vue'
import type { PropType } from 'vue'

defineProps({
  icon: Object as PropType<Component>,
})
</script>
